<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-acknowledgments element-with-heading" id="acknowledgments">
<div class="heading heading-with-title heading-without-image" id="acknowledgments-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Acknowledgments</h1>
</div>
</div>
</div>
</div>
<div class="text" id="acknowledgments-text">
<p class="first first-in-chapter first-full-width"><b>Anita L. Roseboro</b></p>
<p class="subsq">First thank you God, for giving me the gifts to be creative. Naleighna Kai, I am grateful that you considered me to be a part of this project. Thank you to our Beta Readers Debra J. Mitchell, and Kelsie Maxwell.</p>
<p class="subsq">Michelle Rayford, thanks for coming aboard and adding your brand of flair to this project. We must collaborate again. Tribe, thank you just for being there and being an awesome group of ladies and gentlemen.</p>
<p class="subsq">Readers thank you for your support. I hope you find the series enjoyable, and it brings you a laugh or two.</p>
<p class="subsq">Much Love.</p>
<p class="subsq">.</p>
<p class="subsq"><b>Michelle D. Rayford</b></p>
<p class="subsq">My new motto for all things literary is "Say yes and figure it out later." It's a reminder to myself to get out of my comfort zone and take advantage of opportunities when presented to me. Such is the case for this story and I'm so glad I stretched my writing muscle to embody these characters.</p>
<p class="subsq">I would like to thank Naleighna Kai for the vision for this series. My tribe members are always there for assistance with beta reads, late-night conversations, and endless support. </p>
<p class="subsq">To my girls, I hope my example inspires you to pursue your own dreams.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?49c25e8c